// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__35Jza","footer":"ReportModalFilter_footer__1YTic"};